import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import TechTraining from './pages/Techtraining';
import Enroll from './components/Enroll';
import Recruitment from './pages/Recruitment';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import FAQ from './pages/Faq';

// Import all 7 service pages
import ApplicationDevelopment from './pages/Applicationdevelopment'; 
import CybersecurityServices from './pages/Cybersecurityservices';
import WebDevelopment from './pages/Webdevelopment';
import ITDesktopSupport from './pages/Itdesktopsupport';
import CloudSolutions from './pages/Cloudsolutions';
import ITConsultationAuditing from './pages/Itconsultationauditing';
import CreativeDesign from './pages/Creativedesign';

// Scroll to top component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tech-training" element={<TechTraining />} />
          <Route path="/enroll/:programId" element={<Enroll />} />
          <Route path="/recruitment" element={<Recruitment />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<FAQ />} />
          
          {/* All 7 Service Detail Pages */}
          <Route path="/services/application-development" element={<ApplicationDevelopment />} />
          <Route path="/services/cybersecurity-services" element={<CybersecurityServices />} />
          <Route path="/services/web-development" element={<WebDevelopment />} />
          <Route path="/services/it-desktop-support" element={<ITDesktopSupport />} />
          <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
          <Route path="/services/it-consultation-auditing" element={<ITConsultationAuditing />} />
          <Route path="/services/creative-design" element={<CreativeDesign />} />
          
          {/* Alternative routes for tech training and recruitment */}
          <Route path="/services/tech-training" element={<TechTraining />} />
          <Route path="/services/tech-recruitment" element={<Recruitment />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;